module.exports = __webpack_public_path__ + "img/trial1-4.257944d4.png";